import React, { useState } from 'react';
import styled from 'styled-components';
import { TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { convertTimeWithTimezone } from '@/utils/time';
import { OsrPhoneAssociatedCampaign } from '../../types';

const useStyles = makeStyles(() => ({
  copy: {
    cursor: 'pointer',
    marginLeft: '5px',
    color: '#B3B7BB',
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: 'normal',
    textDecorationLine: 'underline',
    '&.copied': {
      color: '#49535D',
      transition: '1s',
    },
  },
}));

const PhoneLink = styled.a`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #00748f;
  text-decoration: underline;
`;

export const formatUSPhoneNumber = (phoneNumber: string) => {
  if (phoneNumber && phoneNumber.length === 11 && phoneNumber.startsWith('1')) {
    const npa = phoneNumber.substring(1, 4);
    const nxx = phoneNumber.substring(4, 7);
    const xxxx = phoneNumber.substring(7);

    return `${npa}-${nxx}-${xxxx}`;
  }
  return phoneNumber;
};

interface Props {
  data: OsrPhoneAssociatedCampaign;
}

const NumbersProvisionedListingRow: React.FC<Props> = (props) => {
  const { data } = props;
  const classes = useStyles();
  const [phoneCopied, setPhoneCopied] = useState(false);

  const handleCopy = (number: string) => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(number);
      setPhoneCopied(true);
      setTimeout(() => {
        setPhoneCopied(false);
      }, 1000);
    }
  };

  return (
    <TableRow data-testid="numbersProvisionedListingRow">
      <TableCell align="left" style={{ width: 245 }} data-testid="phoneNumber">
        <div>
          <PhoneLink href={`/phones/${data.phoneNumber}`}>
            {formatUSPhoneNumber(data.phoneNumber)}
          </PhoneLink>
          <span
            className={`${classes.copy}${phoneCopied ? ' copied' : ''}`}
            onClick={() => handleCopy(formatUSPhoneNumber(data.phoneNumber))}
            data-testid="copyPhoneNumberButton"
          >
            {phoneCopied ? 'copied' : 'copy'}
          </span>
        </div>
      </TableCell>
      <TableCell align="left" style={{ width: 180 }} data-testid="nnid">
        {data.nnid ?? 'N/A'}
      </TableCell>
      <TableCell
        align="left"
        style={{ width: 180 }}
        data-testid="serviceProvider"
      >
        {data.serviceProvider ?? 'N/A'}
      </TableCell>
      <TableCell
        align="left"
        style={{ minWidth: 125 }}
        data-testid="provisionedOn"
      >
        <span>
          {data.startTimestamp
            ? convertTimeWithTimezone(data.startTimestamp)
            : ''}
        </span>
      </TableCell>
    </TableRow>
  );
};

export default NumbersProvisionedListingRow;
